if (typeof CollectionDiscountBundle !== 'function') {
	/**
	 * Fetch cart progress bar
	 * and replace collection progress bar for discounts
	 */
	class CollectionDiscountBundle extends HTMLElement {
		constructor() {
			super();

			this._container				= this;
			this._id					= this.dataset.sectionId;
			this._type					= this.dataset.sectionType;

			this._selectors = {
				cartDrawer				: '[data-js-site-cart-sidebar]',
				finalThreshold			: '[data-final-threshold]',
				progressBar				: '[data-progress-limit]',
				progressContent			: '[data-progress-content',
			};

			// ELEMENTS
			this.progressBar			= this._container.querySelector(this._selectors.progressBar);
			this.progressContent		= this._container.querySelector(this._selectors.progressContent);
			this.drawerCart				= document.querySelector(this._selectors.cartDrawer);

			// VARIABLES
			this.maxThreshold = 0;

			// EVENTS
			document.addEventListener('core:items:loaded', (e) => { this.handleUpdate(e); });

			// Init
			this.init();
		}
		
		/**
		 * Init main core methods on component class init
		 * Fetch cart section and update elements accordingly
		 */
		init() {
			// Fetch section from cart
			fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {
				// Inner cart content
				const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
				if (!sectionInnerHTML) return false;
				// Progress snippet
				const progressSnippetInnerHTML = sectionInnerHTML.querySelector(this._selectors.finalThreshold);

				// Dispatch with detail if it exists
				if (progressSnippetInnerHTML)
					document.dispatchEvent(new CustomEvent('core:items:loaded', { detail: progressSnippetInnerHTML }));
				else if (this.progressBar) {
					this.progressBar.classList.add('hidden');
				}
			});
		}
		

		/**
		 * Handle update
		 */
		handleUpdate(e) {
			// Fail fast
			if (!e?.detail) return this.progressBar.classList.add('hidden');

			// 1. Get incoming percentage
			const percentage = e.detail?.dataset?.progressPercentage ?? 0;
			// 2. Get message content
			const content = e.detail.querySelector(this._selectors.progressContent);

			// 3. Update bar
			this._updateLimitBar(percentage);

			// 4. Update content (message)
			this._updateLimitContent(content);

			// 5. Show bar (if necessary)
			this.progressBar.classList.remove('hidden')
		}

		/**
		 * Update Limit bar HTML element
		 * Updates css var
		 * @param {Number} Percentage
		 */
		_updateLimitBar(percentage) {
			// 1. Round incoming percentage - for older devices
			const roundedPercentage = Math.round(percentage);

			// 2. Update inner bar style width with current percentage, updating the progress CSS variable
			this._container.style.setProperty("--progress-percentage", `${roundedPercentage}%`);

			// 3. Open cart drawer if max limit is reached
			if (roundedPercentage >= 100) {
				const drawerCart = document.querySelector(this._selectors.cartDrawer);
				if (drawerCart)
					drawerCart.show();
			}
		}

		/**
		 * Update inner HTML of
		 * discount messaging
		 * @param {Element} content 
		 */
		_updateLimitContent(content) {
			if (!content && !this.progressContent) return false;
			this.progressContent.innerHTML = content.innerHTML;
		}
	}

	// Init Class
	if (typeof customElements.get('collection-discounts') == 'undefined') {
		customElements.define('collection-discounts', CollectionDiscountBundle);
	}
}